import { referral_ref_secret } from './config.js';

const enc = new TextEncoder();
const dec = new TextDecoder();

function base64UrlEncode(buf) {
  const bin = String.fromCharCode(...new Uint8Array(buf));
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlDecode(str) {
  let b64 = str.replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

async function importAesKey() {
  const hash = await crypto.subtle.digest('SHA-256', enc.encode(referral_ref_secret));
  return crypto.subtle.importKey('raw', hash, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']);
}

/** @param {string} plain */
export async function encryptReferralRef(plain) {
  if (plain == null || plain === '') return '';
  const key = await importAesKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const cipherBuf = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    enc.encode(plain)
  );
  const combined = new Uint8Array(iv.length + cipherBuf.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(cipherBuf), iv.length);
  return base64UrlEncode(combined.buffer);
}

/** @param {string} encoded base64url(iv + ciphertext+tag) */
export async function decryptReferralRef(encoded) {
  if (!encoded || encoded.trim() === '') return '';
  const key = await importAesKey();
  const combined = base64UrlDecode(encoded.trim());
  if (combined.length < 13) throw new Error('invalid ref payload');
  const iv = combined.slice(0, 12);
  const ciphertext = combined.slice(12);
  const plainBuf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ciphertext);
  return dec.decode(plainBuf);
}

/**
 * Value from `searchParams.get('ref')` — decrypts AES payload, or returns raw string for legacy plain `?ref=122` links.
 * @param {string | null} rawFromQuery
 */
export async function resolveReferralRefFromQuery(rawFromQuery) {
  if (rawFromQuery == null || rawFromQuery === '') return null;
  const trimmed = rawFromQuery.trim();
  try {
    const out = await decryptReferralRef(trimmed);
    return out === '' ? null : out;
  } catch {
    return trimmed;
  }
}
